import React from 'react';
import { Server as ServerType, Ticket as TicketType } from '../../types';
import { Server, Wifi, MessageSquare } from 'lucide-react';
import { Announcements } from './Announcements';

interface ClientDashboardProps {
  servers: ServerType[];
  tickets: TicketType[];
  onNavigate: (tab: 'servers' | 'support') => void;
}

const StatCard: React.FC<{ icon: React.ReactNode; title: string; value: number; color: string; onClick: () => void; }> = ({ icon, title, value, color, onClick }) => (
  <div
    onClick={onClick}
    className="bg-white p-6 rounded-xl border border-gray-200 flex items-center space-x-4 shadow-sm hover:shadow-lg hover:border-blue-500 transition-all cursor-pointer"
  >
    <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${color}`}>
      {icon}
    </div>
    <div>
      <p className="text-sm text-gray-500">{title}</p>
      <p className="text-2xl font-bold text-gray-900">{value}</p>
    </div>
  </div>
);

export const ClientDashboard: React.FC<ClientDashboardProps> = ({ servers, tickets, onNavigate }) => {
  const onlineServers = servers.filter(s => s.status === 'online').length;
  const openTickets = tickets.filter(t => t.status === 'abierto' || t.status === 'en_progreso').length;

  return (
    <div className="space-y-8">
      {/* SECCIÓN DE TARJETAS DE ESTADÍSTICAS */}
      <div>
        <h2 className="text-2xl font-bold text-gray-900 mb-6">Resumen de tu Cuenta</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <StatCard
            icon={<Server className="w-6 h-6 text-purple-600" />}
            title="Servidores Totales"
            value={servers.length}
            color="bg-purple-100"
            onClick={() => onNavigate('servers')}
          />
          <StatCard
            icon={<Wifi className="w-6 h-6 text-green-600" />}
            title="Servidores Online"
            value={onlineServers}
            color="bg-green-100"
            onClick={() => onNavigate('servers')}
          />
          <StatCard
            icon={<MessageSquare className="w-6 h-6 text-blue-600" />}
            title="Tickets Abiertos"
            value={openTickets}
            color="bg-blue-100"
            onClick={() => onNavigate('support')}
          />
        </div>
      </div>

      {/* --- [NUEVO] SECCIÓN DEDICADA PARA ANUNCIOS --- */}
      {/* Envolvemos los anuncios en un div con margen superior para separarlos visualmente */}
      <div className="pt-4">
        <Announcements />
      </div>
    </div>
  );
};
